import "./style.css";
import { k } from "./reactive-element-DZ4uc4cT-BmQGLYME-HcXnJBgK-C5QAKziK.js";
import { html as Y } from "./index-CYA3oVVY-hqmzhX60-DijabQOP.js";
import "./lit-element-Bwc3Q88e-BvvsTfdo-Ch2fLuxu-B39NhNnt.js";
import { unsafeSVG as o } from "./index-Cdbsxh_c-omwbRAqr-BdxapMRp.js";
import { d as d$1 } from "./table-cell-DDSj_n2r-BIlh9073-D89bY7q8-TUXkUaoN.js";
import { property as h } from "./index-s3jJ0xl5-CowEOooj-Bsetjq7R.js";
import { state as a$1 } from "./index-uiGwYmGU-B4gTdfzL-u5nzwjdz.js";
import { classMap as f$1 } from "./index-sl1_h-2--CZKxsp0Y-BwpfUZBi.js";
import { h as h$1 } from "./lifecycle-decorators-Cg3csm0R-CIqP0clw-Dtq_Oc7c-B_fw4Bcc.js";
import { A as A$1, b } from "./query-assigned-D4FybMzo-B3FqmBxV-BnfDryTY-Cjsm3_gh.js";
var s = /* @__PURE__ */ ((e) => (e.TEXT = "text", e.NUMERAL = "numeral", e.DATE = "date", e.ICONS = "icons", e))(s || {});
const D = `<svg role="img" aria-label="down" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 11.5L3 4L13 4L8 11.5Z" fill="var(--beacon-system-color-icon-error, #DD3636)"/>
</svg>`, $ = `<svg role="img" aria-label="up" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 4L13 11.5H3L8 4Z" fill="var(--beacon-system-color-icon-positive, #248647)"/>
</svg>`, z = k`:root[beacon-tag-name=beacon-table-record],:root [beacon-tag-name=beacon-table-record],[beacon-version="4.2.2"][class*=beacon-on][beacon-tag-name=beacon-table-record],[beacon-version="4.2.2"][class*=beacon-on] [beacon-tag-name=beacon-table-record],[class*=beacon-on] [beacon-version="4.2.2"][beacon-tag-name=beacon-table-record],[class*=beacon-on] [beacon-version="4.2.2"] [beacon-tag-name=beacon-table-record],[beacon-version="4.2.2"][beacon-tag-name=beacon-table-record],[beacon-version="4.2.2"] [beacon-tag-name=beacon-table-record]{--table-record-zero-value: 0;--table-record-inline-size-content: fit-content;--table-record-unset: unset;--table-record-numeral-gap: 0 var(--beacon-reference-space-4);--table-record-space-margin-inline-end-default: var(--beacon-reference-space-2);--table-record-space-margin-inline-start-default: var(--beacon-reference-space-1)}@media (width >= 640px){:root[beacon-tag-name=beacon-table-record],:root [beacon-tag-name=beacon-table-record],[beacon-version="4.2.2"][class*=beacon-on][beacon-tag-name=beacon-table-record],[beacon-version="4.2.2"][class*=beacon-on] [beacon-tag-name=beacon-table-record],[class*=beacon-on] [beacon-version="4.2.2"][beacon-tag-name=beacon-table-record],[class*=beacon-on] [beacon-version="4.2.2"] [beacon-tag-name=beacon-table-record],[beacon-version="4.2.2"][beacon-tag-name=beacon-table-record],[beacon-version="4.2.2"] [beacon-tag-name=beacon-table-record]{--table-record-space-margin-inline-start-default: var(--beacon-reference-space-2)}}@media (width >= 960px){:root[beacon-tag-name=beacon-table-record],:root [beacon-tag-name=beacon-table-record],[beacon-version="4.2.2"][class*=beacon-on][beacon-tag-name=beacon-table-record],[beacon-version="4.2.2"][class*=beacon-on] [beacon-tag-name=beacon-table-record],[class*=beacon-on] [beacon-version="4.2.2"][beacon-tag-name=beacon-table-record],[class*=beacon-on] [beacon-version="4.2.2"] [beacon-tag-name=beacon-table-record],[beacon-version="4.2.2"][beacon-tag-name=beacon-table-record],[beacon-version="4.2.2"] [beacon-tag-name=beacon-table-record]{--table-record-space-margin-inline-end-default: var(--beacon-reference-space-4);--table-record-space-margin-inline-start-default: var(--beacon-reference-space-4)}}`, S = k`[beacon-tag-name=beacon-table-record][variant=text] :is(h1,h2,h3,h4,h5,h6){font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100)}[beacon-tag-name=beacon-table-record][variant=text] *{margin:0}[beacon-tag-name=beacon-table-record][variant=text]>*+*{margin-block-start:var(--record-text-content-space, var(--beacon-reference-space-5))}[beacon-tag-name=beacon-table-record][variant=text] :last-child{--record-text-content-space: var(--beacon-reference-space-3)}[beacon-tag-name=beacon-table-record] p{margin:0}[beacon-tag-name=beacon-table-record] [beacon-tag-name=beacon-icon-button]{padding:0}[beacon-tag-name=beacon-table-record] [beacon-tag-name=beacon-icon-button]:not(:last-child){margin-inline-end:var(--beacon-reference-space-2)}`, A = k`:host{color:var(--beacon-system-color-text-standard);inline-size:inherit;word-break:initial}.has-cell-padding{padding-block:0;padding-inline:0}.record-cell-wrapper{--margin-end: var(--table-record-space-margin-inline-end-default);--margin-start: var(--table-record-space-margin-inline-start-default);display:flex;gap:var(--beacon-reference-space-5);margin-inline:0}:host([variant=numeral]) .record-cell-wrapper,:host([variant=date]) .record-cell-wrapper,:host([variant=icons]) .record-cell-wrapper{--margin-end: var(--table-record-space-margin-inline-end-default);--margin-start: var(--table-record-space-margin-inline-start-default)}:host([sorting][variant=numeral]) .record-cell-wrapper,:host([sorting][variant=date]) .record-cell-wrapper,:host([sorting][variant=icons]) .record-cell-wrapper{--margin-end: var(--beacon-reference-space-7)}.record-numeral{align-items:flex-end;display:flex;flex-wrap:wrap;gap:var(--table-record-numeral-gap);justify-content:end;margin-block-end:0}.no-content{color:var(--beacon-system-color-text-inactive)}.record-na{color:var(--beacon-system-color-text-standard)}.record-cell{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100);flex-grow:1;margin-block-start:0}.record-cell:is(.numeral,.date){display:grid;gap:var(--beacon-reference-space-1);text-align:end}.record-cell.icons{align-items:center;display:flex;justify-content:end}.record-cell.bold .record-na,.record-cell.sorted .record-na{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-body-100)}.record-delta{align-items:center;display:flex;gap:var(--beacon-reference-space-1)}.record-delta-value{color:var(--beacon-system-color-text-standard)}.record-delta-icon{block-size:var(--beacon-reference-space-5);display:inline-block;inline-size:var(--beacon-reference-space-5)}.record-footnote{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-200);color:var(--beacon-system-color-text-standard);margin:0}.empty{display:none}.action-zone:not(.empty){display:var(--table-record-zero-value, grid);grid-template-rows:0;inline-size:var(--table-record-inline-size-content);margin-block-start:0;place-items:center}.hide{display:none}`;
var N = Object.defineProperty, C = Object.getOwnPropertyDescriptor, t = (e, n, l, r) => {
  for (var c = r > 1 ? void 0 : r ? C(n, l) : n, b2 = e.length - 1, p; b2 >= 0; b2--)
    (p = e[b2]) && (c = (r ? p(n, l, c) : p(c)) || c);
  return r && c && N(n, l, c), c;
};
const f = "beacon-table-record", T = Y`&#8212`;
var d;
const a = (d = class extends d$1 {
  constructor() {
    super(...arguments), this.beaconTagName = f, this.variant = s.TEXT, this.sorted = false, this.hasActionZoneContent = false;
  }
  static get styles() {
    return [super.styles, A];
  }
  static get lightDOMStyles() {
    return [...super.lightDOMStyles, S, z];
  }
  /**
   * Returns sign of delta to determine delta icon styles
   *
   * @returns true/false for positive/negative respectively
   */
  get deltaPositive() {
    return this.slottedDelta > 0;
  }
  setActionZoneStatus() {
    this.hasActionZoneContent = this.actionZone.length > 0;
  }
  deltaSlotChange() {
    let e;
    this.slottedDeltaNodes.length > 0 && (e = this.slottedDeltaNodes.map((n) => {
      var l, r;
      return (r = (l = n.textContent) == null ? void 0 : l.trim()) != null ? r : "";
    }).join("")), e && (this.slottedDelta = parseFloat(e));
  }
  /**
   * Renders slot element with default styles
   * @returns default empty slot styles
   */
  static renderSlot() {
    return Y`<span class="record-na"
      ><slot><span class="no-content">${T}</span></slot></span
    >`;
  }
  /**
   * Renders numeral and delta with proper spacing
   * @returns HTML template for numeral element in numeral record
   */
  renderNumeral() {
    const e = this.slottedDelta && !this.hideDeltaIcon ? Y`<span class="record-delta-icon">
            ${this.deltaPositive ? o($) : o(D)}
          </span>` : Y``, n = {
      "record-delta-value": true,
      hide: !this.slottedDelta || this.hideDeltaValue
    };
    return Y` <span class="record-delta"> ${e}<span class=${f$1(n)}><slot name="delta" @slotchange=${this.deltaSlotChange}></span></slot></span>${d.renderSlot()}`;
  }
  /**
   * Conditionally renders cell contents
   * @returns HTML template according to variant type
   */
  renderCell() {
    switch (this.variant) {
      case s.NUMERAL:
        return Y`<div class="record-numeral">${this.renderNumeral()}</div>
          <p class="record-footnote"><slot name="footnote"></slot></p>`;
      case s.DATE:
      case s.TEXT:
      case s.ICONS:
      default:
        return d.renderSlot();
    }
  }
  /**
   * Default render function
   * @returns HTML template for table record component
   */
  render() {
    return Y`<div class="record-cell-wrapper" part="cell-wrapper">
      <div
        class="has-cell-padding record-cell ${this.bold ? "bold" : ""} ${this.sorted ? "sorted" : ""} ${this.variant}"
        part="cell">
        ${this.renderCell()}
      </div>
      ${this.variant === s.NUMERAL ? Y`<div
            class="action-zone ${f$1({
      empty: !this.hasActionZoneContent
    })}"
            part="action-zone">
            <slot name="action-zone"></slot>
          </div>` : Y``}
    </div>`;
  }
}, d.tagName = f, d);
t([
  h({ reflect: true })
], a.prototype, "variant", 2);
t([
  a$1()
], a.prototype, "slottedDelta", 2);
t([
  A$1({ flatten: true, slot: "delta" })
], a.prototype, "slottedDeltaNodes", 2);
t([
  h({ attribute: "sort-value", reflect: true })
], a.prototype, "sortValue", 2);
t([
  h({ type: Boolean, reflect: true })
], a.prototype, "bold", 2);
t([
  h({ type: Boolean, reflect: true })
], a.prototype, "sorted", 2);
t([
  h({ type: Boolean, reflect: true, attribute: "hide-delta-icon" })
], a.prototype, "hideDeltaIcon", 2);
t([
  h({
    type: Boolean,
    reflect: true,
    attribute: "hide-delta-value"
  })
], a.prototype, "hideDeltaValue", 2);
t([
  a$1()
], a.prototype, "hasActionZoneContent", 2);
t([
  b({ slot: "action-zone" })
], a.prototype, "actionZone", 2);
t([
  h$1
], a.prototype, "setActionZoneStatus", 1);
let Z = a;
const R = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BeaconTableRecord: Z
}, Symbol.toStringTag, { value: "Module" }));
export {
  s as i,
  R as index,
  Z as k
};
